import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../../api/axiosInstance";

const PlatformFeatureForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [form, setForm] = useState({
    title: "",
    description: "",
    icon: "",
    order: 0,
    isActive: true,
    showOnHome: true,
    showOnAbout: true
  });

  const load = async () => {
    const res = await api.get(`/api/platform-features`);
    const feature = res.data.find((f) => f._id === id);
    if (feature) setForm(feature);
  };

  useEffect(() => {
    if (id) load();
  }, [id]);

  const submit = async (e) => {
    e.preventDefault();
    if (id) {
      await api.put(`/api/platform-features/${id}`, form);
    } else {
      await api.post("/api/platform-features/platform-feature", form);
    }
    navigate("/admin/platform-features");
  };

  return (
    <form onSubmit={submit} className="max-w-xl space-y-4">
      <h1 className="text-xl font-bold">
        {id ? "Edit Feature" : "Create Feature"}
      </h1>

      {["title", "icon"].map((field) => (
        <input
          key={field}
          className="w-full border p-2 rounded"
          placeholder={field}
          value={form[field]}
          onChange={(e) =>
            setForm({ ...form, [field]: e.target.value })
          }
        />
      ))}

      <textarea
        className="w-full border p-2 rounded h-28"
        placeholder="Description"
        value={form.description}
        onChange={(e) =>
          setForm({ ...form, description: e.target.value })
        }
      />

      <input
        type="number"
        className="w-full border p-2 rounded"
        placeholder="Order"
        value={form.order}
        onChange={(e) =>
          setForm({ ...form, order: Number(e.target.value) })
        }
      />

      {["isActive", "showOnHome", "showOnAbout"].map((field) => (
        <label key={field} className="flex gap-2">
          <input
            type="checkbox"
            checked={form[field]}
            onChange={(e) =>
              setForm({ ...form, [field]: e.target.checked })
            }
          />
          {field}
        </label>
      ))}

      <button className="bg-primary text-white px-4 py-2 rounded">
        Save
      </button>
    </form>
  );
};

export default PlatformFeatureForm;
